import React, { useContext } from 'react';
import { Button } from '@material-ui/core';
import {makeStyles} from "@material-ui/core/styles";

import {SocketContext} from "../SocketContext";

const useStyles = makeStyles((theme) => ({
    answerButton: {
        marginLeft: 20,
        // background: "rgb(131,58,180)",
        background: "linear-gradient(90deg, rgba(131,58,180,1) 0%, rgba(253,29,29,1) 50%, rgba(252,176,69,1) 100%)",
        borderRadius: 3,
        border: 0,
        color: 'white',
        height: 48,
        padding: '0 30px',
        boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
        
      }
   }));


const Notifications = () => {
    const {answerCall, call, callAccepted} = useContext(SocketContext);
    const classes = useStyles();
    return (
        <>
            {call.isReceivedCall && !callAccepted && (
                <div style={{display: 'flex', justifyContent: 'center', marginTop: '20px'}}>
                    <h1>{call.name} is calling: </h1>
                    <Button variant="contained" color="primary" onClick={answerCall} className={classes.answerButton}>
                        Answer
                    </Button>
                </div>
            )}
        </>
    )
}

export default Notifications
